export const initialQuantityState = {
  quantities: {},
  defaultQuantity: 4,
};

export const createQuantitySlice = (set, get) => ({
  ...initialQuantityState,

  setQuantity: (tyreId, quantity) => {
    const val = quantity ? Math.min(Math.max(quantity, 1), 999) : 1;
    set((state) => ({
      quantities: { ...state.quantities, [tyreId]: val },
    }));
  },

  getQuantity: (tyreId) => {
    const { quantities, defaultQuantity } = get();
    return quantities[tyreId] || defaultQuantity;
  },

  setDefaultQuantity: (qty) => set({ defaultQuantity: qty }),
});
